import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global error handler to filter out non-critical third-party script errors
window.addEventListener('error', (event) => {
  // Filter out eWay script errors that don't affect functionality
  if (event.message === 'Script error.' && 
      event.filename && 
      event.filename.includes('eCrypt.js')) {
    console.warn('Suppressed non-critical eWay script error:', event.message);
    event.preventDefault();
    return false;
  }
  
  // Log other errors normally but don't show overlay in production
  if (event.message !== 'Script error.') {
    console.error('JavaScript Error:', {
      message: event.message,
      source: event.filename,
      line: event.lineno,
      column: event.colno,
      error: event.error
    });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);